module.exports = __webpack_public_path__ + "img/img21.b6576782.svg";